var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('content',{staticClass:"content has-text-centered"},[(_vm.error)?_c('span',[_c('b',[_vm._v(_vm._s(_vm.error))]),_c('br'),_c('br')]):_vm._e(),_vm._v("\n\n    "+_vm._s(_vm.$t(`description.${_vm.status}`))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }